module.exports = __webpack_public_path__ + "img/Shawarma_Meal_Lamb.4481a0c7.jpg";